export default {
    meg: {
        username: 'username',
        email:'email'
    }
}